import { createContext } from 'react';

export default createContext('AppContext');


// WEBPACK FOOTER //
// ./src/containers/App/AppContext.js